export const toggleOverlay = (value) => {
  return {
    type: "SWITCH_SHOW_NOTIFICATION",
    payload: value,
  };
};
